"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PopupDatePickerContext = void 0;
exports.usePopupDatePickerContext = usePopupDatePickerContext;

var _react = require("react");

var PopupDatePickerContext = /*#__PURE__*/(0, _react.createContext)(undefined);
exports.PopupDatePickerContext = PopupDatePickerContext;

function usePopupDatePickerContext() {
  var context = (0, _react.useContext)(PopupDatePickerContext);

  if (context === undefined) {
    throw new Error('usePopupDatePickerContext should be inside of PopupDatePickerContext.Provider');
  }

  return context;
}

PopupDatePickerContext.displayName = 'PopupDatePickerContext';